module.exports = __webpack_public_path__ + "static/media/FoodIconsFinal.af3b8ed0.jpg";